{
  "internalPortal": {
    "pages": {
      "organizations": {
        "title": "Organizations",
        "new": "New organization",
        "subtitle": "Manage client organizations, locations & spend"
      }
    },
    "components": {
      "organizationsTable": {
        "columns": {
          "organizationName": "Organization name",
          "parentOrganization": "Parent organization",
          "status": "Status",
          "primaryContact": "Primary contact",
          "locations": "Locations",
          "inScopeSpend": "In scope spend",
          "savingsIdentified": "Savings identified",
          "savingsApproved": "Savings approved",
          "openAudits": "Open audits",
          "more": "More"
        },
        "noData": {
          "withFilters": {
            "title": "No organizations match your filters",
            "description": "Try adjusting your filters to find what you're looking for"
          },
          "withoutFilters": {
            "title": "No organizations found",
            "description": "No organizations found, you can create them by clicking the button in the top right corner."
          }
        }
      },
      "organizationFilters": {
        "options": {
          "all": "All",
          "active": "Active",
          "inactive": "Inactive",
          "withSubsidiary": "With subsidiary organizations"
        }
      },
      "tabs": {
        "overview": "Overview",
        "billPay": "BillPay",
        "subsidiaryOrg": "Subsidiary org",
        "locations": "Locations",
        "vendors": "Vendors",
        "vendorAccounts": "Vendor Accounts",
        "spendSavings": "Spend & Savings",
        "documents": "Documents",
        "work": "Work",
        "sibContracts": "SIB Contracts",
        "audits": "Audits",
        "futureOpportunities": "Future opportunities",
        "billing": "Billing"
      },
      "tabPlaceholder": {
        "title": "We're working on it",
        "description": "This view is not available yet"
      },
      "billPay": {
        "title": "BillPay",
        "agent": {
          "title": "Bill pay agent"
        },
        "sections": {
          "billPayFundingFrequency": "BillPay Funding Frequency",
          "fundingDetailsSubmissionMethod": "Funding Details Submission Method",
          "billingAddress": "Billing address",
          "mailingAddress": "Mailing address"
        },
        "editForm": {
          "title": "Edit BillPay details",
          "success": "BillPay details updated successfully",
          "error": "BillPay details update failed",
          "options": {
            "billPayFundingFrequency": {
              "monthly": "Monthly",
              "quarterly": "Quarterly"
            },
            "fundingDetailsSubmissionMethod": {
              "email": "Email",
              "sftp": "SFTP"
            }
          }
        }
      }
    }
  },
  "views": {
    "organizationView": {
      "tooltip": {
        "addNewStep": "Only client result managers can add new action items",
        "addNewTeam": "Only client result managers can add new team",
        "vectorOrganizationNotSupported": "Ticket creation is unavailable for Vector organizations"
      },
      "actionItemList": {
        "label": "Action items",
        "categoryLabel": {
          "fileUpload": "File upload",
          "meeting": "Meeting",
          "other": "Other"
        }
      },
      "newEntityButton": "New",
      "buttonOption": {
        "task": "Team task",
        "actionItem": "Action item",
        "team": "Team",
        "email": "E-mail",
        "subAudit": "SubAudit",
        "actionItemFromTemplates": "Action item from templates",
        "ticket": "Ticket"
      },
      "members": "Members",
      "past": "Past",
      "memberList": {
        "assignedTasks": "{{taskCount}} assigned tasks",
        "you": "You"
      },
      "pinOrganization": {
        "pin": "Pin to dashboard",
        "unpin": "Remove from dashboard",
        "view": "View",
        "activeTasks_one": "{{count}} Active Task",
        "activeTasks_other": "{{count}} Active Tasks"
      },
      "subAudit": {
        "button": "SubAudits"
      }
    }
  },
  "components": {
    "organizationDetailsHeader": {
      "breadcrumb": {
        "organizationList": "Organization list"
      },
      "moreMenu": {
        "label": "More options"
      },
      "scheduleMeeting": "Schedule meeting",
      "parentOrg": "parent org:",
      "badges": {
        "subsidiaryOrg": "Subsidiary org",
        "onboarded": "Onboarded"
      },
      "metrics": {
        "inScopeSpend": "In-scope spend:",
        "savingsIdentified": "Savings identified:",
        "savingsApproved": "Savings approved:"
      },
      "mainPointOfContact": "Main point of contact",
      "fields": {
        "phone": "Phone",
        "website": "Website",
        "websiteLink": "Link",
        "dba": "DBA",
        "currentValidator": "Current Validator",
        "accountRecordType": "Account Record Type",
        "originatingDivision": "Originating Division",
        "sibAutorenewalApproved": "SIB Autorenewal Approved",
        "salesforceSalesId": "Salesforce Sales ID",
        "sf2AccountUrl": "Salesforce Account",
        "sf2AccountLink": "Link",
        "industry": "Industry",
        "subIndustry": "Sub-industry",
        "annualRevenue": "Annual Revenue",
        "numberOfEmployees": "Number of employees",
        "primarySalesRep": "Primary Sales Rep",
        "clientWhoSignedSibSa": "Client Who Signed SIB SA"
      }
    },
    "organizationDetails": {
      "error": {
        "title": "Failed to load organization"
      }
    },
    "noDataPlaceholder": {
      "title": "No client members are assigned to this organization",
      "description": "Share access to SpendBrain and add first member to get started"
    },
    "organizationList": {
      "title": "My Organizations",
      "noOrganizationFound": "No organizations found",
      "membersCount": "{{count}} members",
      "activeTasksCount": "{{count}} active tasks",
      "other": "Other",
      "placeholder": "Find organization",
      "recentlySelected": "Recently selected",
      "sortBy": {
        "options": {
          "all": "All",
          "activeTasks": "Active tasks",
          "membership": "Membership"
        }
      }
    },
    "organizationEmailForm": {
      "title": "New Email",
      "fields": {
        "recipients": {
          "label": "Send to",
          "placeholder": "Select contact"
        },
        "title": {
          "label": "Title",
          "placeholder": "Email title"
        },
        "message": {
          "label": "Message",
          "placeholder": "Message"
        },
        "cc": {
          "label": "Add to thread",
          "placeholder": "Select contact"
        },
        "createTask": {
          "label": "Create related task"
        }
      },
      "submit": "Send",
      "task": {
        "title": "Send email: {{emailSubject}}",
        "description": "Send email with body:\n{{emailBody}}"
      }
    }
  },
  "enums": {
    "OrganizationStatus": {
      "dormant": "Dormant",
      "mobilization": "Mobilization",
      "negotiation": "Negotiation",
      "post_negotiation": "Post-negotiation",
      "pre_negotiation": "Pre-negotiation",
      "prospect": "Prospect",
      "update_required": "Update required",
      "validation": "Validation"
    },
    "AuditStatus": {
      "open": "Open",
      "cancelled": "Cancelled",
      "pending": "Pending",
      "on_hold": "On hold",
      "completed": "Completed"
    },
    "AuditStage": {
      "mobilization": "Mobilization",
      "spend_estimated": "Spend estimated",
      "negotiations": "Negotiations",
      "negotiations_vendor": "Negotiations – Vendor",
      "negotiations_client": "Negotiations – Client",
      "savings_realized": "Savings realized",
      "monitoring_savings": "Monitoring savings"
    },
    "VendorAccountStatus": {
      "active": "Active",
      "inactive": "Inactive"
    }
  }
}
